/**
 * بیس آدرس را میگیرد و بر اساس آن کلید شامل متن ارسالی را برمیگرداند
 */
export const getKeyBreadCrumbsWithUrl = (currentLoaction, containTest = 'IMPREST') => {
    return String(currentLoaction?.pathname).toUpperCase().includes(containTest) ? constBreadCrumbsTitle.IMPREST_CARDS : constBreadCrumbsTitle.BFO_CARDS
}
export const creatDynamicBreadcrumbs = (currentLocation) => {
    // const { pathname, search } = currentLocation;
    // let myPath = String(pathname).trim().toUpperCase();
    // let mySearch = String(search).trim().toUpperCase();
    // let specificParam = mySearch.toUpperCase().includes('PATHNAME');
    // myPath = term(myPath);

    // const finalString = myPath + (specificParam ? '?PATHNAME' : '');
    // return getBreadCrumbs[finalString];

    return getBreadCrumbs[currentLocation]

}
const term = (str) => {
    let s = '';
    if (String(str).charAt(str.length - 1) === '/') {
        s = str.substring(0, str.length - 1);
        return term(s);
    } else {
        return str;
    }
}

export const constBreadCrumbsTitle = {
    /**
     * Imprest/cards
     */
    IMPREST_CARDS: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'دفترچه',
        },
    ],

    /**
     * Cards
     */
    BFO_CARDS: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'دفترچه',
        },
    ],

    /**
     * accounts
     */
    BFO_ACCOUNTS: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
        },
    ],

     REPORT_SUMMERY_IMPREST: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان ',
            link: '/Imprest',
        },
        {
            title: 'گزارش تجمیعی تنخواه',
        },
    ],

    /**
     * /Imprest/DepositReport/:id
     */
    REPORT_DEPOSIT_IMPREST: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان ',
            link: '/Imprest',
        },
        {
            title: 'گزارش واریزی‌ها',
        },
    ],

    /**
     * imprest/accounts
     */
    IMPREST_ACCOUNTS: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
        },
    ],

    /**
     * imprest/transfercredit
     */
    IMPREST_TRANSFERCREDIT_BYMENU: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'انتقال وجه پادی',
        },
    ],
    /**
     * transfercredit
     */
    TRANSFERCREDIT_BYMENU: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'انتقال وجه پادی',
        },
    ],

    /**
     * settlementWallet
     */
    SETTLEMENT_WALLET: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: "گزارش درخواست‌های تسویه",
        },
    ],

    /**
 * imprest/settlementWallet
 */
    IMPREST_SETTLEMENT_WALLET: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: "گزارش درخواست‌های تسویه",
        },
    ],

    /**
     * TransactionsWallet/:id
     */
    TRANSACTIONWALLET_WITH_ID: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Accounts',
        },
        {
            title: 'صورت حساب تراکنش',
        },
    ],
    /**
     * TransactionsWallet
     */
    TRANSACTIONWALLET_WITHOUT_ID: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'گزارش صورتحساب دیجیتال',
        },
    ],

    /**
    * imprest/TransactionsWallet
    */
    IMPREST_TRANSACTIONWALLET_WITHOUT_ID: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'گزارش صورتحساب دیجیتال',
        },
    ],

    /**
        *  /TransactionsWallet/:ID?sourceMenu=IMPREST
        */
    IMPREST_TRANSACTIONWALLET_WITH_ID: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',

            link: '/Imprest/Accounts',
        },
        {
            title: 'گزارش صورتحساب دیجیتال',
        },
    ],



    /**
     * /WalletCartableCashout/:id
     */
    WALLET_CARTABLE_CASHOUT: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال ',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Accounts',
        },
        {
            title: 'برداشت وجه',
        },
    ],
    WALLET_CASHOUT: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال ',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Accounts',
        },
        {
            title: 'برداشت وجه',
        },
    ],

    /**
     * /WalletCartableCashout/:id?sourceMenu=IMPREST
     */
    'imprestWalletCartableCashout':
        [
            {
                title: 'خدمات تنخواه گردانی',
                link: null,
            },
            {
                title: 'حساب دیجیتال ',
                link: null,
            },
            {
                title: 'حساب دیجیتال من',
                link: '/Imprest/Accounts',
            },
            {
                title: 'برداشت وجه',
            },
        ],

    /**
* /WalletCartableCashout/:id
*/
    'walletCashout': [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال ',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Accounts',
        },
        {
            title: 'برداشت وجه',
        },
    ],

    /**
     * /WalletCartableCashout/:id?sourceMenu=IMPREST
     */
    IMPREST_WALLET_CARTABLE_CASHOUT:
        [
            {
                title: 'خدمات تنخواه گردانی',
                link: null,
            },
            {
                title: 'حساب دیجیتال ',
                link: null,
            },
            {
                title: 'حساب دیجیتال من',
                link: '/Imprest/Accounts',
            },
            {
                title: 'برداشت وجه',
            },
        ],

    /**
     * /WalletCartableCashout/:id?sourceMenu=IMPREST
     */
    IMPREST_WALLET_CASHOUT:
        [
            {
                title: 'خدمات تنخواه گردانی',
                link: null,
            },
            {
                title: 'حساب دیجیتال ',
                link: null,
            },
            {
                title: 'حساب دیجیتال من',
                link: '/Imprest/Accounts',
            },
            {
                title: 'برداشت وجه',
            },
        ],

    /**
     * TransferCreditWallet/:id
     */
    TRANSFERCREDIT_WALLET: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Accounts',
        },
        {
            title: 'انتقال وجه',
        },
    ],
    /**
   * TransferCreditWallet/:id?sourceMenu=IMPREST
   */
    IMPREST_TRANSFERCREDIT_WALLET: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Imprest/Accounts',
        },
        {
            title: 'انتقال وجه',
        },
    ],


    /**
     *  /Permission/GrantedWallet
     */
    PERMISSION_GRANTED_WALLET: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Accounts',
        },
        {
            title: 'مجوزهای مالی اعطا شده',
        },
    ],

    /**
     *  /Permission/GrantedWallet?sourceMenu=IMPREST
     */
    IMPREST_PERMISSION_GRANTED_WALLET: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Imprest/Accounts',
        },
        {
            title: 'مجوزهای مالی اعطا شده',
        },
    ],


    /**
     *  /Permission/ReceivedWallet
     */
    PERMISSION_RECEIVED_WALLET: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Accounts',
        },
        {
            title: 'مجوزهای مالی دریافت شده',
        },
    ],
    /**
     *  /Permission/ReceivedWallet?sourceMenu=IMPREST
     */
    IMPREST_PERMISSION_RECEIVED_WALLET: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'حساب دیجیتال من',
            link: '/Imprest/Accounts',
        },
        {
            title: 'مجوزهای مالی دریافت شده',
        },
    ],

    /**
     *  /GroupTransferCreditList
     */
    GROUP_TRANSFERCREDIT_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'انتقال وجه پادی',
            link: '/TransferCredit',
        },
        {
            title: 'عملیات گروهی',
        },
    ],

    /**
     *  /GroupTransferCreditList?sourceMenu=IMPREST
     */
    IMPREST_GROUP_TRANSFERCREDIT_LIST: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'انتقال وجه پادی',
            link: '/Imprest/TransferCredit',
        },
        {
            title: 'عملیات گروهی',
        },
    ],

    /**
       * /GroupTransfercredit/:ID
       */
    GROUP_TRANSFERCREDIT_DETAIL: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'انتقال وجه پادی',
            link: null,
        },
        {
            title: 'عملیات گروهی',
            link: '/GroupTransferCreditList',
        },
        {
            title: 'جزئیات',
        },
    ],

    /**
     * /GroupTransfercredit/:ID?sourceMenu=IMPREST
     */
    IMPREST_GROUP_TRANSFERCREDIT_DETAIL: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'انتقال وجه پادی',
            link: null,
        },
        {
            title: 'عملیات گروهی',
            link: '/GroupTransferCreditList?sourceMenu=IMPREST',
        },
        {
            title: 'جزئیات',
        },
    ],

    /**
     * Acl/AddGroup
     */
    ACL_ADD: [
        {
            title: 'مدیریت کسب‌وکار',
            link: null,
        },
        {
            title: 'ایجاد دسترسی ',
        },
    ],

    /**
     * /Acl/EditGroup/:path
     */
    ACL_EDIT: [
        {
            title: 'مدیریت کسب‌وکار',
            link: null,
        },
        {
            title: 'مدیریت دسترسی‌ها',
            link: '/Acl',
        },
        {
            title: 'ویرایش دسترسی',
        },
    ],

    /**
     * /Acl
     */
    ACL_LIST: [
        {
            title: 'مدیریت کسب‌وکار',
            link: null,
        },
        {
            title: ' مدیریت دسترسی‌ ها',
        },
    ],

    /**
     * /Acl/AddUser/:path
     */
    ACL_ADD_USER: [
        {
            title: 'مدیریت کسب‌وکار',
            link: null,
        },
        {
            title: ' مدیریت دسترسی‌ ها',
            link: '/Acl',
        },
        {
            title: 'لیست کاربران',
        },
    ],

    /**
     * /BillsPaymentList
     */
    BILL_PAYMENT_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'مدیریت قبوض',
            link: null,
        },
        {
            title: 'گزارش پرداخت قبوض',
        },
    ],

    /**
     * /BillsPayment
     */
    BILLS_PAYMENT: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'مدیریت قبوض',
            link: null,
        },
        {
            title: 'پرداخت قبوض',
        },
    ],

    /**
     * /BonusCard/List
      */
    BONUSCARD_LIST: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'بن کارت',
            link: null,
        },
        {
            title: 'لیست بن کارت ',
        },
    ],

    /**
     * /BusinessInfo
    */
    BUSINESS_INFO: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'ویرایش اطلاعات کسب‌و‌کار',
        },
    ],

    /**
     * /CartableDelegation
     */
    CARTABLE_DELEGATION: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'کارتابل',
            link: null,
        },
        {
            title: 'لیست حساب های چند امضایی',
            link: '/Cartable/List',
        },
        {
            title: 'تفویض وجه',
        },
    ],

    /**
     * /Cartable/List
     */
    CARTABLE_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'کارتابل',
            link: null,
        },
        {
            title: 'لیست حساب ها',
        },
    ],

    /***
     * /CartableRequest/List
     */
    CARTABLE_REQUEST_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'کارتابل',
            link: null,
        },
        {
            title: 'لیست درخواست ها',
        },
    ],

    /**
     * /CartableTransferCredit/:id
     */
    CARTABLE_TRANSFER_CREDIT: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'کارتابل',
            link: null,
        },
        {
            title: 'لیست حساب های چند امضایی',
            link: '/Cartable/List',
        },
        {
            title: 'انتقال وجه',
        },
    ],

    /**
     * /RequestPayDetails/:id
     */
    CARTABLE_REQUEST_PAY_DETAIL: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'کارتابل',
            link: null,
        },
        {
            title: 'لیست درخواست‌ها',
            link: '/CartableRequest/List',
        },
        {
            title: 'جزئیات درخواست',
        },
    ],

    /**
     * /GuildCashout/:id
     */
    GUILD_CASHOUT: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: 'لیست حساب‌ها',
            link: '/Guilds',
        },
        {
            title: 'برداشت وجه',
        },
    ],

    /**
     * /NewRequestConfirmation
     */
    NEW_REQUEST_CONFIRMATION: [
        {
            title: 'تایید یا ارتقای کسب‌وکار',
            link: null,
        },
        {
            title: 'درخواست جدید',
        },
    ],
   /**
     * /RequestConfirmation/:id
     */
    REQUEST_CONFIRMATION_EDIT: [
        {
            title: 'تایید یا ارتقای کسب‌وکار',
            link: null,
        },
        {
            title: 'لیست درخواست‌ها',
            link: '/RequestConfirmation',
        },
        {
            title: 'ویرایش درخواست',
        },
    ],
    /**
     * /RequestConfirmation/:id
     */
    REQUEST_CONFIRMATION: [
        {
            title: 'تایید یا ارتقای کسب‌وکار',
            link: null,
        },
        {
            title: 'لیست درخواست‌ها',
            link: '/RequestConfirmation',
        },
        {
            title: 'جزئیات درخواست',
        },
    ],

    /**
     * /RequestConfirmation
     */
    REQUEST_CONFIRMATION_AUTH: [
        {
            title: 'مدیریت کسب‌وکار',
            link: null,
        },
        {
            title: 'احراز هویت کسب‌وکار',
        },
    ],

    /**
     * /Followers
     */
    CUSTOMER_LIST: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'لیست مشتریان',
        },
    ],

    /**
     * /Dealer/List
     */
    DEALER_LIST: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'کارگزاری',
            link: null,
        },
        {
            title: 'لیست کارگزاری های من',
        },
    ],

    /**
     * /Dealer/DealingList
     */
    DEALING_LIST: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'کارگزاری',
            link: null,
        },
        {
            title: 'مجوزهای کارگزاری من',
        },
    ],

    /**
     * /DefineDelegation/List
     */
    DEFINE_DELEGATION_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تفویض وجه',
            link: null,
        },
        {
            title: 'وجه‌های تفویض شده به سایرین',
        },
    ],

    /**
     * /Voucher/AddCreditVoucher
     */
    VOUCHER_ADD_CREDIT_VOUCHER: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'بن شارژ',
            link: null,
        },
        {
            title: 'ایجاد بن شارژ',
        },
    ],

    /**
     * /CreditVoucher/:id
     */
    VOUCHER_CREDIT_VOUCHER_DETAIL: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'بن شارژ',
            link: null,
        },
        {
            title: 'لیست بن‌های شارژ',
            link: '/CreditVoucher',
        },
        {
            title: 'اطلاعات بن شارژ',
        },
    ],

    /**
     * /CreditVoucher
     */
    CREDIT_VOUCHER_LIST: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'بن شارژ',
            link: null,
        },
        {
            title: 'لیست بن‌های شارژ',
        },
    ],

    /**
     * /DefineDelegation
     */
    DELEGATION_BY_MENU: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تفویض وجه',
            link: null,
        },
        {
            title: 'تفویض وجه تکی/گروهی',
        },
    ],

    /**
     * /DirectDebit
     */
    DIRECT_DEBIT: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'مجوزهای برداشت مستقیم از حساب بانکی',
        },
    ],

    /**
     * /Voucher/AddVoucher
     */
    VOUCHER_ADD_VOUCHER: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'بن تخفیف',
            link: null,
        },
        {
            title: 'ایجاد بن تخفیف',
        },
    ],

    /**
     * /Voucher
     */
    VOUCHER_LIST: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'بن تخفیف',
            link: null,
        },
        {
            title: 'لیست بن‌های تخفیف',
        },
    ],

    /**
     * Voucher/Detail/:id
     */
    VOUCHER_DETAILS: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'بن تخفیف',
            link: null,
        },
        {
            title: 'لیست بن‌های تخفیف',
            link: '/Voucher',
        },
        {
            title: 'اطلاعات بن تخفیف',
        },
    ],

    /**
     * /Delegation
     */
    DELEGATION_ME: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تفویض وجه',
            link: null,
        },
        {
            title: 'وجه‌های تفویض شده به من',
        },
    ],

    /**
     * /WithdrawRule
     */
    WITHDRAW_RULE: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: 'مجوزهای برداشت از حساب دیجیتال من',
        },
    ],

    /**
     * /Guilds
     */
    GUILD_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: 'لیست حساب‌ها',
        },
    ],

    /**
     * /InvoiceCreditor
     */
    INVOICE_CREDITOR: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'فاکتورهای خرید',
        },
    ],

    /**
     * /grant-permission/list
     */
    GRANT_PERMISSION_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: "مجوزهای مالی",
        },
    ],

    /**
     * /IncomeByGuilds
     */
    INCOME_BY_GUILDS: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'گزارش درآمد براساس حساب تفصیلی',
        },
    ],

    /**
     * /IncomeByProducts
     */
    INCOME_BY_PRODUCTS: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'گزارش درآمد براساس محصولات',
        },
    ],

    /**
     * /Invoice
     */
    INVOICE_LIST: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'فاکتورهای فروش',
        },
    ],

    /**
     * /IssueInvoice
     */
    ISSUE_INVOICE: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'صدور فاکتور',
        },
    ],

    /**
     * /ProfileDetailInvoice?InvoiceId=3695142
    */
    PROFILE_DETAIL_INVOICE: [
        {
            title: 'عملیات مالی',
            link: null,
        },
        {
            title: 'فاکتورهای فروش',
            link: '/Invoice',
        },
        {
            title: 'جزئیات پروفایل پرداخت',
        },
    ],

    /**
     * /Invoice/:id/invoice-reduce
     */
    INVOICE_REDUCE: [
        {
            title: 'عملیات مالی',
            link: null,
        },
        {
            title: 'فاکتورهای فروش',
            link: '/Invoice',
        },
        {
            title: 'کاهش فاکتور',
        },
    ],

    /**
     * /SettlementList/123/details
     */
    SETTLEMENTLIST_DETAILS: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
        {
            title: "گزارش درخواست‌های تسویه",
        },
        {
            title: "شرح سند",
        },
    ],


    /**
     * /InvoiceFinancing/Invoices
     */
    FINANCIALSUPPLY_INVOICEFINANCING_INVOICES: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تأمین مالی',
            link: null,
        },
        {
            title: 'فاکتورهای تأمین مالی شده',
        },
    ],

    /**
     * /InvoiceFinancing/Invoices/:id
     */
    FINANCIALSUPPLY_INVOICEFINANCING_INVOICES_ID: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تأمین مالی',
            link: null,
        },
        {
            title: 'درخواست اعتبار',
            link: '/InvoiceFinancing/Requests',
        },
        {
            title: 'جزئیات قرارداد',
        },
    ],

    /**
     * /InvoiceFinancing/Requests
     */
    FINANCIALSUPPLY_INVOICEFINANCING_REQUESTS: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تأمین مالی',
            link: null,
        },
        {
            title: 'درخواست اعتبار ',
        },
    ],

    /**
     * /Funder/Transactions/:id
     */
    FUNDER_TRANSACTIONS: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: ' گزارش کل تنخواه',
            link: '/funderImprestReport',
        },
        {
            title: 'صورت حساب ',
        },
    ],

    /**
     * /GroupDelegationList
     */
    GROUP_DELEGATION_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تفویض وجه',
            link: null,
        },
        {
            title: 'تفویض وجه تکی/گروهی',
            link: '/DefineDelegation',
        },
        {
            title: 'عملیات گروهی',
        },
    ],

    /**
     * /GroupDelegation/:id
     */
    GROUP_DELEGATION_DETAILS: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تفویض وجه',
            link: null,
        },
        {
            title: 'تفویض وجه تکی/گروهی',
            link: null,
        },
        {
            title: 'عملیات گروهی',
            link: '/GroupDelegationList',
        },
        {
            title: 'جزئیات تفویض وجه‌های گروهی',
        },
    ],

    /**
     * /Imprest/Add
     */
    IMPREST_ADD: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'ایجاد شعبه تنخواه گردان',
        },
    ],

    /**
     * Imprest/:id
     */
    IMPREST_EDIT: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'ویرایش تنخواه گردان ',
        },
    ],
    /**
     * /funderImprestReport
     */
    FUNDER_IMPREST_REPORT: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'گزارش کل تنخواه',
        },
    ],

    /**
     * /Imprest/IssueInvoice/:id
     */
    IMPREST_ISSUEINVOICE: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'صدور فاکتور از طرف',
        },
    ],

    /**
     * /imprest
     */
    IMPREST_LIST: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
        },
    ],

    /**
     * /Imprest/ReceiveInventory/:id
     */
    IMPREST_RECEIVE_INVENTORY: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'موجودی تنخواه',
        },
    ],

    /**
     * /Imprest/SettlementList/:id
     */
    IMPREST_SETTLEMENTLIST: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'برداشت وجه',
            link: null,
        },
    ],

    /**
     * /Imprest/ImprestTransferCredit
     */
    IMPREST_IMPREST_TRANSFERCREDIT: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'انتقال وجه تکی از طرف تنخواه‌گردان',
        },
    ],

    /**
     * Keys/EditApiKey/:id
   
     */
    KEYS_EDIT_API_KEY: [
        {
            title: 'ورود یکپارچه',
            link: null,
        },

        {
            title: 'ویرایش کلید',
        },
    ],

    /**
     *   /Keys/AddApiKey
     */
    KEYS__ADD_API_KEY: [
        {
            title: 'ورود یکپارچه',
            link: null,
        },

        {
            title: 'افزودن کلید جدید',
        },
    ],

    /**
     * /Keys
     */
    KEYS_LIST: [
        {
            title: 'ورود یکپارچه',
            link: null,
        },
        {
            title: 'لیست کلیدها',
        },
    ],

    /**
     * /Loan/:id/details
     */
    LOAN_DETAILS: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تسهیلات و اعتبارات',
            link: null,
        },
        {
            title: 'فروش اقساطی کسب و کار',
            link: '/Loan',
        },
        {
            title: 'جزییات تسهیلات',
        },
    ],

    /**
     * /Loan
     */
    LOAN_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تسهیلات و اعتبارات',
            link: null,
        },
        {
            title: 'فروش اقساطی کسب‌وکار',
        },
    ],

    /**
     * /LoanInvoice
     */
    LOAN_INVOICE: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'تسهیلات و اعتبارات',
            link: null,
        },
        {
            title: 'تسهیلات دریافتی',
        },
    ],

    /**
     * /services/my-service-calls
     */
    SERVICES_MYSERVICECALLS: [
        {
            title: 'میز کار سرویس‌دهنده',
            link: null,
        },
        {
            title: 'فراخوانی سرویس‌های من',
        },
    ],

    /**
     * /Permission/GrantedGuild
     */
    PERMISSION_GRANTED_GUILD: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: 'لیست حساب‌ها',
            link: '/Guilds',
        },
        {
            title: 'مجوزهای مالی اعطا شده',
        },
    ],

    /**
     * /Permission/ReceivedGuild
     */
    PERMISSION_RECEIVED_GUILD: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: 'لیست حساب‌ها',
            link: '/Guilds',
        },
        {
            title: 'مجوزهای مالی دریافت شده',
        },
    ],

    /**
     * /walletAndGuild
     */
    WALLETANDGUILD: [
        {
            title: 'گزارشات',
            link: null,
        },
        {
            title: 'گزارش تلفیقی',
        },
    ],

    /**
     * /ReportOfflineTransactions
     */
    REPORT_OFFLINE_TRANSACTIONS: [
        {
            title: 'لیست درخواست گزارشات',
            link: null,
        },
    ],

    /**
     * /RequestWebServices
     */
    REQUEST_WEBSERVICES: [
        {
            title: 'میز کار سرویس‌گیرنده',
            link: null,
        },
        {
            title: 'درخواست‌های ارسالی',
        },
    ],

    /**
     * /ReceivedRequestWebService/:invoiceId/detail
     */
    RECEIVED_REQUEST_WEBSERVICE_DETAIL: [
        {
            title: 'میز کار سرویس‌دهنده',
            link: null,
        },
        {
            title: 'درخواست‌های دریافتی',
            link: '/ReceivedRequestWebService',
        },
        {
            title: 'لیست جزییات درخواست‌ دریافتی',
        },
    ],

    /**
     * /ReceivedRequestWebService
     */
    RECEIVED_REQUEST_WEBSERVICE: [
        {
            title: 'میز کار سرویس‌دهنده',
            link: null,
        },
        {
            title: 'درخواست‌های دریافتی',
        },
    ],

            /**
     * /services/service-calls
     */
    SERVICES_SAYAH_INQUIRY: [
        {
            title: 'میز کار',
            link: null,
        },
        {
            title: 'استعلام سیاح',
        },
    ],


    /**
     * /services/service-calls
     */
    SERVICES_SERVICECALLS: [
        {
            title: 'میز کار سرویس‌گیرنده',
            link: null,
        },
        {
            title: 'فراخوانی سرویس‌ها',
        },
    ],

    /**
     * /services/service-providers
     */
    SERVICES_SERVICE_PROVIDERS: [
        {
            title: 'میز کار سرویس‌دهنده',
            link: null,
        },
        {
            title: 'گزارش فراخوانی‌ها',
        },
    ],


    /**
     * /WebService/Add
     */
    SERVICES_SERVICESET_CREATE: [
        {
            title: 'میز کار سرویس‌دهنده',
            link: null,
        },
        {
            title: 'تعریف مجموعه سرویس جدید',
        },
    ],

    /**
     * /services/service-set
     */
    SERVICES_SERVICESET: [
        {
            title: 'میز کار سرویس‌دهنده',
            link: null,
        },
        {
            title: 'مجموعه سرویس‌های من',
        },
    ],

    SELTTLEMENT_LIST_SETTLEMENT_DETAILS: [
        {
            title: 'گزارش تراکنش',
            link: null,
        },
        {
            title: 'جزییات تسویه',
        },
    ],

    SETTLEMENT_GUILD: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: 'گزارش درخواست‌های تسویه',
        },
    ],

    SETTLEMENT_GUILD_WITH_ID: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: 'لیست حساب‌ها',
            link: '/Guilds',
        },
        {
            title: 'گزارش درخواست‌های تسویه',
        },
    ],

    SETTLEMENTLIST_INVOCIE: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: 'لیست فاکتورها',
        },
    ],

    SUBSCRIPTIONS_ASSIGNED: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'طرح اشتراک',
            link: null,
        },
        {
            title: 'طرح‌های تعریف شده',
        },
    ],


    /**
     * /subscriptions/assigned/delegation-details/:id
     */
    SUBSCRIPTIONS_ASSIGNED_DELEGATION: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'طرح اشتراک',
        },
        {
            title: 'طرح‌های تعریف شده',
            link: '/subscriptions/assigned',
        },
        {
            title: 'گزارش طرح ایجاد شده',
            link: null,
        },
    ],

    /**
     * /subscriptions/create
     */
    SUBSCRIPTIONS_CREATE: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'طرح اشتراک',
            link: null,
        },
        {
            title: 'ایجاد طرح اشتراک',
        },
    ],
    /**
     * /subscriptions/assigned/id
     */
    SUBSCRIPTIONS_EDIT: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'طرح اشتراک',
            link: null,
        },
        {
            title: 'طرح های تعریف شده',
            link: '/subscriptions/assigned',
        },
        {
            title: 'ویرایش طرح اشتراک',
        },
    ],

    /**
     * /subscriptions/received
     */
    SUBSCRIPTIONS_RECEIVED: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'طرح اشتراک',
            link: null,
        },
        {
            title: 'طرح‌های فعال',
        },
    ],

    /**
     * /subscriptions/received/13173?planId=30010
     */
    SUBSCRIPTIONS_RECEIVED_WITH_ID: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'طرح اشتراک',
            link: null,
        },
        {
            title: 'طرح های فعال',
            link: '/subscriptions/received',
        },
        {
            title: 'لیست سرویس های فعال',
        },
    ],

    SUBBUSINESS_ADD: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها ',
            link: null,
        },
        {
            title: 'افزودن زیرمجموعه',
        },
    ],

    /**
     * /Branch/Add
     */
    BRANCH_ADD: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: 'ایجاد شعبه جدید',
        },
    ],

    /**
     * /Branch/31474/detail
     */
    BRANCH_DETAILS: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها ',
            link: null,
        },
        {
            title: 'لیست شعبه‌ها',
            link: '/Branch',
        },
        {
            title: 'جزئیات',
        },
    ],
    IMPREST_DETAILS: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'جزئیات',
        },
    ],

    /**
     * /Branch/31474/financial
     */
    BRANCH_FINANCIAL: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها ',
            link: null,
        },
        {
            title: 'لیست شعبه ها',
            link: '/Branch',
        },
        {
            title: 'سقف مالی شعبه',
        },
    ],

    /**
     * /Branch/31474/financial?imprest=true
     */
    IMPREST_FINANCIAL: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },

        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'سقف مالی تنخواه گردان',
        },
    ],

    /**
     * /Branch
     */
    BRANCH_LIST: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: 'لیست شعبه ها',
        },
    ],

    /**
     * /Branch/Transactions/id?imprest=true
     */
    BRANCH_TRANSACTIONS: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: 'لیست شعبه ها',
            link: '/Branch',
        },
        {
            title: 'صورت حساب تراکنش',
        },
    ],
    /**
     * Branch/Transactions/id
     */
    IMPREST_TRANSACTIONS: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'صورت حساب تراکنش',
            link: null,
        },
    ],

    /**
     * /Branch/id
     */
    EDIT_BRNACH: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: 'لیست شعبه‌ها',
            link: '/Branch',
        },
        {
            title: 'ویرایش شعبه',
        },
    ],
    /**
     * /SubBusiness/id
     */
    SUBBUSINESS_EDIT: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: 'زیرمجموعه‌های من',
            link: '/SubBusiness',
        },
        {
            title: 'ویرایش زیر مجموعه',
        },
    ],

    SUBBSET_DETAILS: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: 'زیرمجموعه‌های من',
            link: '/SubBusiness',
        },
        {
            title: 'جزییات کسب‌وکار',
        },
    ],

    SUBBUSINESS_LIST: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: 'زیرمجموعه‌های من',
        },
    ],

    /**
     * /Ticket/Create
     */
    TICKET_CREATE: [
        {
            title: 'پشتیبانی',
            link: null,
        },
        {
            title: 'ثبت درخواست پشتیبانی',
        },
    ],

    /**
     * ticket/804129/804128/4114/detail?ticketCat=support
     */
    TICKET_SUPPORT_DETAILS: [
        {
            title: 'پشتیبانی',
            link: null,
        },
        {
            title: 'درخواست های پشتیبانی فنی',
            link: '/Ticket/List/support',
        },
        {
            title: 'جزییات درخواست',
        },
    ],

    /**
     * ticket/804129/804128/4114/detail
     */
    TICKET_SALE_DETAILS: [
        {
            title: 'پشتیبانی',
            link: null,
        },
        {
            title: 'درخواست های مدیریت مشتریان پاد',
            link: '/Ticket/List/sale',
        },
        {
            title: 'جزییات درخواست',
        },
    ],

    /**
     * 
     */
    TICKET_FAQ: [
  
        {
            title: 'سوالات متداول',
        },
    ],

    TICKET_SALE_LIST: [
        {
            title: 'پشتیبانی',
            link: null,
        },
        {
            title: 'درخواست های مدیریت مشتریان پاد',
            link: null,
        },
    ],

    TICKET_SUPPORT_LIST: [
        {
            title: 'پشتیبانی',
            link: null,
        },
        {
            title: 'درخواست های پشتیبانی فنی',
            link: null,
        },
    ],

    MENU_BRANCH_TRANSACTIONS: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: 'گزارش صورتحساب شعب',
        },
    ],

    MENU_IMPREST_TRANSACTIONS: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'گزارش صورتحساب تنخواه گردان ها',
        },
    ],

        MENU_IMPREST_TRANSACTIONS_REPORT: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
        },
        {
            title: 'گزارش صورتحساب تنخواه گردان ها',
        },
    ],



    /**
     * /TransactionsGuild/id
     */
    TRANASACTIONS_GUILDS_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: 'لیست حساب‌ها',
            link: '/Guilds',
        },
        {
            title: 'صورت حساب تراکنش',
        },
    ],
    /**
     * /TransactionsGuild
     */
    TRANASACTIONS_GUILDS_LIST_WITH_ID: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: '/Guilds',
        },
        {
            title: 'گزارش صورتحساب تفصیلی',
        },
    ],

    /**
     * /TransferCreditGuild/id
     */
    TRANSFERCREDIT_GUILD: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی',
            link: null,
        },
        {
            title: 'لیست حساب‌ها',
            link: '/Guilds',
        },
        {
            title: 'انتقال وجه',
        },
    ],

    /**
     * /TransferScore
     */
    TRANSFERSCORE: [
        {
            title: 'مدیریت کسب‌وکار',
            link: null,
        },
        {
            title: 'انتقال امتیاز (سکه)',
        },

    ],
    /**
     * TransferScorelist
     */
    TRANSFERSCORE_LIST: [
        {
            title: 'مدیریت کسب‌وکار',
            link: null,
        },
        {
            title: 'گزارش انتقال امتیاز',
        },
    ],

    /**
     * /transferToBranch
     *  */
    TRANSFER_TRANSFER_TO_BRANCH: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه ها و زیرمجموعه ها',
            link: null,
        },
        {
            title: 'لیست شعبه ها',
            link: '/Branch',
        },
        {
            title: 'شارژ شعبه',
        },
    ],

    /**
     * TransferToCustomer
     */
    TRANSFER_TRANSFER_TO_CUSTOMER: [
        {
            title: 'فروش و مشتریان',
            link: null,
        },
        {
            title: 'لیست مشتریان',
            link: '/Followers',
        },
        {
            title: 'انتقال وجه به کاربر دیگر',
        },
    ],


    /**
     * /TransferToImprest
     */
    TRANSFER_TRANSFER_TO_IMPREST: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'شارژ تنخواه',
        },
    ],

    /**
     * /WithdrawToParent/id
     */
    WITHDRAW_TO_PARENT: [
        {
            title: 'خدمات تنخواه‌گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه‌گردان',
            link: '/Imprest',
        },
        {
            title: 'عودت وجه',
        },
    ],

    /**
     * user-settings
     */
    USER_SETTINGS: [
        {
            title: 'مدیریت کسب‌وکار',
            link: null,
        },
        {
            title: 'مدیریت کاربری',
        },
    ],

    /**
     * /Warranty/RequestDetail/:id
     */
    WARRANTY_REQUEST_DETAILS: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'ضمانت‌نامه دیجیتال',
            link: null,
        },
        {
            title: 'لیست درخواست ها',
            link: '/Warranty/RequestList'
        },
        {
            title: 'جزئیات درخواست',
        },
    ],

    /**
     * /Warranty/RequestList
     */
    WARRANTY_REQUEST_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: '  ضمانت‌نامه دیجیتال ',
            link: null,
        },
        {
            title: 'لیست درخواست ها',
        },
    ],

    /**
     * /Warranty/Request
     */
    WARRANTY_REQUEST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'ضمانت‌نامه دیجیتال',
            link: null,
        },
        {
            title: 'درخواست صدور',
        },
    ],

    /**
     * /WebService/Add
    */
    WEBSERVICE_ADD: [
        {
            title: 'میز کار سرویس‌دهنده',
            link: null,
        },
        {
            title: 'تعریف سرویس جدید',
        },
    ],

    /**
     * /services/web-services/:id/edit
     */
    WEBSERVICE_EDIT: [
        {
            title: 'میز کار سرویس‌دهنده',
            link: null,
        },
        {
            title: 'سرویس‌های من',
            link: '/WebService',
        },
        {
            title: 'ویرایش وب سرویس',
        },
    ],

    WEBSERVICE_LIST: [
        {
            title: 'میز کار سرویس‌دهنده',
            link: null,
        },
        {
            title: 'سرویس‌های من',
        },
    ],

    /**
     * /WithdrawRules/CustomersRules
     *  */
    WITHDRAWRULES_CUSTOMERS_RULES: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'مجوزهای برداشت از حساب مشتری',
            link: null,
        },
        {
            title: 'لیست مجوزهای برداشت',
        },
    ],

    /**
     * /WithdrawRules/NewRule
     */
    WITHDRAWRULES_NEW_RULE: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'مجوزهای برداشت از حساب مشتری',
            link: null,
        },
        {
            title: 'قانون برداشت جدید',
        },
    ],

    /**
     * /WithdrawRules/RulesList
     */
    WITHDRAWRULES_RULES_LIST: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: ' مجوزهای برداشت از حساب مشتری',
            link: null,
        },
        {
            title: 'لیست قوانین برداشت',
        },
    ],

    /**
     * DelegationToUser?Type=Branch 
     */
    BRANCH_DELEGATION_TO_USER: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: 'لیست شعبه‌ها',
            link: '/Branch',
        },
        {
            title: 'تفویض وجه',
        },
    ],

    /**
     * /DelegationToUser?Type=SubBusiness
     */
    SUBBUSINESS_DELEGATION_TO_USER: [
        {
            title: 'مدیریت کسب‌و‌کار',
            link: null,
        },
        {
            title: 'شعبه‌ها و زیرمجموعه‌ها',
            link: null,
        },
        {
            title: ' زیرمجموعه‌های من',
            link: '/SubBusiness',
        },
        {
            title: 'تفویض وجه',
        },
    ],

    /**
     * /DelegationToUser?Type=Imprest
     */
    IMPREST_DELEGATION_TO_USER: [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: 'تفویض وجه',
            link: null,
        },
    ],

    /**
     * GuildCartableCashOut/:id?
     */
    GUILD_CARTABLE_CASHOUT: [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب‌های تفصیلی ',
            link: null,
        },
        {
            title: 'لیست حساب‌ها',
            link: '/Guilds',
        },
        {
            title: 'برداشت وجه',
        },
    ],

        /**
     * Imprest/card
     */
    IMPREST_CARD: (value) => [
        {
            title: 'خدمات تنخواه گردانی',
            link: null,
        },
        {
            title: 'لیست تنخواه گردان',
            link: '/Imprest',
        },
        {
            title: value,
        },
    ],
    WALLET_CARD: (value) => [
        {
            title: 'عملیات مالی و بانکی',
            link: null,
        },
        {
            title: 'حساب دیجیتال',
            link: null,
        },
          {
            title: 'حساب دیجیتال من',
            link: null,
        },
        {
            title: value,
        },
    ],

}


